export default __webpack_public_path__ + "static/media/egg_static.ced3cd5e.gif";